<section class="banner" [style]="{
    '--color-1' : colors[0],
    '--color-2' : colors[1],
    '--color-3' : colors[2],
    '--color-4' : colors[3],
    '--color-5' : colors[4]
}">
    <app-nav class="w-100"></app-nav>

    <app-category-searchbar [searchText]="''" [colors]="colors"></app-category-searchbar>

    <div #air id="air" class='air kenburns-top'></div>
</section>


<app-skelitions *ngIf="!filtersLoaded" [value]="7"></app-skelitions>
<section #dataSection *ngIf="filtersLoaded" >
    <app-category-ous [currentDataItem]="currentDataItem"
        [current]="catdata" [colors]="colors"></app-category-ous>
    

    <app-data-view  [currentview]="data_items[0]"
        (currentDataItem)="changeCurrentDataItem($event)" [editPermission]="editPermission" *ngIf="filtersLoaded"
        [searchVal]="searchbarSearchValue" [data]="data_items" [current]="catdata" [colors]="colors"></app-data-view>
</section>

<app-footer></app-footer>